import { type FC } from "react";
import { type ProductData } from "~/domains/product/types/ProductData";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";
import { Product } from "~/domains/product/Product";
import { useTranslation } from "react-i18next";
import { Typography } from "~/common/mui";

interface ProductProps {
  entry: OrderLineItemData;
}

export const ShipmentProduct: FC<ProductProps> = ({ entry }) => {
  const product: ProductData = entry.product;

  return (
    <>
      <Product.PdpLink product={product} target="_blank">
        <Product.DesignationV2 variant="titleMedium" component={"b"} product={product} color="text.secondary" />
      </Product.PdpLink>
    </>
  );
};

export const ShipmentQuantity: FC<ProductProps> = ({ entry }) => {
  const { t } = useTranslation();

  return (
    <Typography variant="titleMedium" component={"b"}>
      {t("cartPage.shipmentDetails.table.header.packageNumberValues", {
        index: entry.shippedQty,
        totalCount: entry.qty,
      })}
    </Typography>
  );
};
